import type IdentityPolicyRepository from "@/core/administration/repositories/IdentityPolicyRepository";
import type { IdentityPolicy } from "@/core/administration/entities/IdentityPolicy";
import { RepositoryResult } from "@/core/shared/types/RepositoryResult";
import { HttpClient } from "../../http/HttpClient";
import { ApiResponse } from "../../api/types/ApiResponse";
import { executeRequest } from "../../http/services/executeRequest/executeRequest";
import identityPolicyEndpoints from "../../api/identityPolicyEndpoints/identityPolicyEndpoints";

type IdentityPolicyDto = {
  changeRequiresReason: boolean;
  updatedBy: string | null;
  updatedAt: string | null;
};

function mapDto(dto: IdentityPolicyDto): IdentityPolicy {
  return {
    changeRequiresReason: dto.changeRequiresReason,
    updatedBy: dto.updatedBy,
    updatedAt: dto.updatedAt,
  };
}

export default class IdentityPolicyRepositoryBackend
  implements IdentityPolicyRepository
{
  constructor(private readonly httpClient: HttpClient) {}

  getPolicy(): Promise<RepositoryResult<IdentityPolicy>> {
    return executeRequest(
      () =>
        this.httpClient.get<ApiResponse<IdentityPolicyDto>>({
          url: identityPolicyEndpoints.policy(),
          withAuth: true,
        }),
      mapDto,
    );
  }

  updatePolicy(
    changeRequiresReason: boolean,
  ): Promise<RepositoryResult<IdentityPolicy>> {
    return executeRequest(
      () =>
        this.httpClient.put<
          ApiResponse<IdentityPolicyDto>,
          { changeRequiresReason: boolean }
        >({
          url: identityPolicyEndpoints.policy(),
          body: { changeRequiresReason },
          withAuth: true,
        }),
      mapDto,
    );
  }
}
